import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function OAuthFinish() {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) {
      navigate("/login?google=error&reason=no_token", { replace: true });
      return;
    }
    localStorage.setItem("jf_token", token);
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        navigate("/app/dashboard", { replace: true });
      })
      .catch(() => {
        localStorage.removeItem("jf_token");
        navigate("/login?google=error&reason=auth_failed", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#070709] text-white">
      <div className="text-center">
        <div className="font-display text-2xl mb-3">Signing you in…</div>
        <div className="text-white/50 text-sm">This will only take a second.</div>
      </div>
    </div>
  );
}
